import { CycleHistory, PondMediaFilter, PondResponse } from 'modules/pond/api/types'
import { atom } from 'recoil'

export const selectedPondState = atom<PondResponse | null>({
  key: 'selectedPondState',
  default: null,
})

export const selectedCycleIdState = atom<string | null>({
  key: 'selectedCycleIdState',
  default: null,
})

export const currentCycleInfoState = atom<CycleHistory | null>({
  key: 'currentCycleInfoState',
  default: null,
})

export const pondMediaFilterState = atom<PondMediaFilter>({
  key: 'pondMediaFilterState',
  default: {
    date: null,
    sort: '',
    tag: '',
  },
})

export const pondAgeFilterState = atom<{ min: number | null; max: number | null }>({
  key: 'pondAgeFilterState',
  default: { min: null, max: null },
})
